import { format } from 'date-fns';

const TrendsDataTable = ({ processedTrendData, currentAggregation }) => {
  if (!processedTrendData.length) return null;

  const totalRequests = processedTrendData.reduce((sum, item) => sum + item.count, 0);
  const totalSuccessful = processedTrendData.reduce((sum, item) => sum + item.successfulDiets, 0);
  const totalWarnings = processedTrendData.reduce((sum, item) => sum + item.dietsWithWarning, 0);
  const totalNoDiets = processedTrendData.reduce((sum, item) => sum + item.noDiets, 0);

  const pct = (value, total) => total ? Math.round((value / total) * 100) : 0;

  const getTableHeader = () => {
    switch (currentAggregation) {
      case 'daily': return 'Date';
      case 'weekly': return 'Week';
      case 'monthly': return 'Month';
      default: return 'Period';
    }
  };

  const formatDateForTable = (item) => {
    switch (currentAggregation) {
      case 'daily':
        return format(new Date(item.date), 'MMM dd, yyyy');
      case 'weekly':
        return item.periodLabel || `Week of ${format(new Date(item.date), 'MMM dd, yyyy')}`;
      case 'monthly':
        return format(new Date(item.date), 'MMMM yyyy');
      default:
        return item.displayDate;
    }
  };

  return (
    <div className="relative bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden" data-intro="data-table">
      {/* Tour anchor for table - positioned at table top */}
      <div className="absolute top-0 left-0 w-full h-10 pointer-events-none z-10" data-intro="data-table-tour" style={{zIndex: 1}}></div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400" data-intro="data-table-header">
            <tr>
              <th className="px-6 py-3">{getTableHeader()}</th>
              <th className="px-6 py-3">Total</th>
              <th className="px-6 py-3 text-emerald-600 dark:text-emerald-400">Successful</th>
              <th className="px-6 py-3 text-amber-600 dark:text-amber-400">With Warning</th>
              <th className="px-6 py-3 text-red-600 dark:text-red-400">No Diets</th>
            </tr>
          </thead>
          <tbody>
            {processedTrendData.slice().reverse().map((item, index) => (
              <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">
                  {formatDateForTable(item)}
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200">
                    {item.count}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-800 dark:text-emerald-100">
                    {item.successfulDiets} ({pct(item.successfulDiets, item.count)}%)
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-800 dark:text-amber-100">
                    {item.dietsWithWarning} ({pct(item.dietsWithWarning, item.count)}%)
                  </span>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100">
                    {item.noDiets} ({pct(item.noDiets, item.count)}%)
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-gray-200 dark:bg-gray-700">
            <tr>
              <td className="px-6 py-4 font-bold text-gray-900 dark:text-white">
                Total
              </td>
              <td className="px-6 py-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-gray-200 text-gray-900 dark:bg-gray-600 dark:text-gray-100">
                  {totalRequests}
                </span>
              </td>
              <td className="px-6 py-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-200 text-emerald-900 dark:bg-emerald-700 dark:text-emerald-100">
                  {totalSuccessful} ({pct(totalSuccessful, totalRequests)}%)
                </span>
              </td>
              <td className="px-6 py-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-200 text-amber-900 dark:bg-amber-700 dark:text-amber-100">
                  {totalWarnings} ({pct(totalWarnings, totalRequests)}%)
                </span>
              </td>
              <td className="px-6 py-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-red-200 text-red-900 dark:bg-red-700 dark:text-red-100">
                  {totalNoDiets} ({pct(totalNoDiets, totalRequests)}%)
                </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default TrendsDataTable;
